import Icon from "@ant-design/icons";
import type { LucideIcon } from "lucide-react";

const MENU_ICON_SIZE = 14;
const MENU_ICON_STROKE = 2;

export function lucideMenuIcon(IconComponent: LucideIcon) {
  return (
    <Icon
      component={() => (
        <IconComponent size={MENU_ICON_SIZE} strokeWidth={MENU_ICON_STROKE} />
      )}
    />
  );
}
